import { apiClient } from '@/services/api'

interface PaymentConfig {
  bankName: string
  accountNumber: string
  accountHolderName: string
}

interface ConfigItem {
  key: string
  value: string
  valueType: string
  description: string
}

let cachedConfig: PaymentConfig | null = null

export async function getPaymentConfig(): Promise<PaymentConfig> {
  if (cachedConfig) return cachedConfig

  try {
    const response = await apiClient.get<ConfigItem[]>('/admin/config')
    const configs: ConfigItem[] = Array.isArray(response.data) ? response.data : []

    cachedConfig = {
      bankName: configs.find(c => c.key === 'payment_bank_name')?.value || 'BCA',
      accountNumber: configs.find(c => c.key === 'payment_account_number')?.value || '',
      accountHolderName: configs.find(c => c.key === 'payment_account_holder_name')?.value || '',
    }
    return cachedConfig
  } catch (error) {
    return {
      bankName: 'BCA',
      accountNumber: '',
      accountHolderName: '',
    }
  }
}

export function clearPaymentConfigCache() {
  cachedConfig = null
}
